export class CookieConsentsDTO {
  /**
   * Consent for proposals-related cookies.
   */
  proposals!: boolean;

  /**
   * Consent for search-related cookies.
   */
  search!: boolean;

  /**
   * Consent for marketing-related cookies.
   */
  marketing!: boolean;

  /**
   * Consent for experience-related cookies.
   */
  experience!: boolean;

  /**
   * Constructs a CookieConsentsDTO with the given partial consents.
   */
  constructor(params: Partial<CookieConsentsDTO>) {
    Object.assign(this, {
      proposals: params.proposals ?? false,
      search: params.search ?? false,
      marketing: params.marketing ?? false,
      experience: params.experience ?? false,
    });
  }
}
